"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var UrlCatalog_1 = require("./src/UrlCatalog");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(UrlCatalog_1).default; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSwrQ0FBMkM7QUFBbEMsc0hBQUEsT0FBTyxPQUFBIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/url-catalog/index.js
// module id = 89
// module chunks = 25